<template>
  <div style="margin-bottom:30px">
    <img src="" alt="">
        <div class="patternQuestionFAQ" @click="$emit('toogleOpen',index)">
            <div class="circle_icon">
               <md-icon>{{icon}}</md-icon>
            </div>
            <div style="margin-left:10px; padding-top:3px">{{faq.question}}</div>
        </div>
        <div class="patternAnswerFAQ patternText" :class="classCss">
            <div v-for="(a, i) in faq.answer" :key="i">
                <div v-if="!a.includes('.png')">
                    {{a}}<br/><br/>
                </div>
                <div v-else>
                    <img :src="require(`../assets/${a}`)" :alt="a" /><br/><br/>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    name: 'FAQ',
    props: ['faq', 'index', 'icon', 'classCss']
}
</script>

<style scoped lang="scss">

    .patternQuestionFAQ{
        cursor: pointer;
        display: inline-flex;
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 24px;
        line-height: 28px;
        text-transform: capitalize;
        color: #1937a0f5;
         &:hover{
            color: #4766d6f5;
        }
    }

    .patternAnswerFAQ{
        opacity: 0;
        max-height: 0px;
        overflow-y: hidden;
    }
    

    .circle_icon{
        cursor: pointer;
        display: flex;
        margin: 0;
        min-width: 15px;
        min-height: 15px;
        height: 35px;
        width: 35px;
        border-radius: 20px;
        background-color: #fff;
        border: 2px solid #FFFFFF;
        box-sizing: border-box;
        box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.25);

        &:hover{
            background-color: #eee;
        }
    }

    .show{
        max-height: initial;
        opacity: 1;
        overflow-y: hidden;
        transition: all 0.4s ease;
        max-width: 1000px;
    }



  
</style>